import GoBackHeader from 'components/organisms/GoBackHeader'
import { useAppDispatch, useAppSelector } from 'hooks/store'
import { FC, useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import { Redirect } from 'react-router-dom'
import {
  setCurrentActiveGroup,
  setCurrentActiveQuestionId
} from 'reducers/activesection/activesectionSlice'
import { DoneContainer } from './styles'
import ProgressBarComponent from '../Components/ProgressBar'

const QuestionnaireDone: FC = () => {
  const dispatch = useAppDispatch()
  const activeSection = useAppSelector((state) => state.activeSection)
  const [toSummaryPage, setToSummaryPage] = useState<boolean>(false)

  function getSectionId() {
    if (activeSection) {
      if (activeSection.section) {
        if (activeSection.section.id) {
          return activeSection.section.id
        }
      }
    }
    return 0
  }

  function goBackHeaderOnClick() {
    dispatch(setCurrentActiveQuestionId(null))
    setToSummaryPage(true)
  }

  useEffect(() => {
    const sectionName = activeSection.section?.sectionName as string
    const sessionStore = window.sessionStorage
    let storedSectionsDoneVisited = JSON.parse(
      sessionStore.getItem('asections-done-visited') || '{}'
    )
    if (!storedSectionsDoneVisited || !storedSectionsDoneVisited[sectionName]) {
      storedSectionsDoneVisited = {
        ...storedSectionsDoneVisited,
        [sectionName]: true
      }
      sessionStore.setItem(
        'asections-done-visited',
        JSON.stringify(storedSectionsDoneVisited)
      )
    }
  }, [])

  if (toSummaryPage) {
    return (
      <Redirect
        to={`/dashboard/questionnaires/sectionsummary/${getSectionId()}`}
      />
    )
  }

  return (
    <>
      <GoBackHeader
        text={activeSection.section?.sectionName}
        onClick={goBackHeaderOnClick}
      />
      <ProgressBarComponent
        currentProgress={100}
        progressText={`${activeSection.section?.sectionName} Section Progress`}
      />
      <DoneContainer>
        <div className='done-header'>{` Good job! You’ve reached the end of the ${activeSection.section?.sectionName} section! `}</div>
        <div className='done-description'>{`You can now go back to the ${activeSection.section?.sectionName} summary to review your answers and mark the section as complete.`}</div>
        <div style={{ display: 'flex' }}>
          <Button
            data-testid='goto-summary-btn'
            onClick={() => {
              dispatch(setCurrentActiveGroup(null))
              dispatch(setCurrentActiveQuestionId(null))
              setToSummaryPage(true)
            }}
            className='goto-summary-btn'
          >
            Go to Section Summary
          </Button>
        </div>
      </DoneContainer>
    </>
  )
}

export default QuestionnaireDone
